// extracted by mini-css-extract-plugin
module.exports = {"addToCalendarLabel":"styles_addToCalendarLabel__ODHeO"};